import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TAgreements, TTradeDetailsById } from "../types/trades/trades";
import moment from "moment";
import {
  DateRange,
  TMandiBankSofwarePartners,
  TMandiEmployeeDetais,
  TMarketAction,
  TMarketDetailsById,
  TMarketImgs,
} from "../types/markets";
import { TAllMarkets } from "../types/markets/market";
import { TLoanFiltersData } from "../types";

const marketSavedFiltersStr = localStorage.getItem("marketFilters");
const marketSavedFilters = marketSavedFiltersStr
  ? JSON.parse(marketSavedFiltersStr)
  : null;
type TInitialState = {
  dateRange: DateRange;
  openMarketDetailsPanel: boolean;
  marketAddPanel: boolean;
  marketDetailsEditStatus: boolean;
  allMarketsData: TAllMarkets[];
  refreshMarketsData: boolean;
  filteredMarketsData: TAllMarkets[];
  marketsFiltersPanelOpenStatus: boolean;
  marketFilters: {
    markets: TLoanFiltersData[];
    rms: TLoanFiltersData[];
    status: string[];
    filterMode: "All" | "";
  };
  selectedMarketId: number;
  marketDeatisById: TMarketDetailsById | null;
  bankPartnersData: TMandiBankSofwarePartners[];
  mandiEmployeesData: TMandiEmployeeDetais[];
  addMarketDetails: TMarketDetailsById;
  softwarePartnersData: TMandiBankSofwarePartners[];
  marketImages: TMarketImgs[];
  refreshAllMarketsEntity: boolean;
  marketAddEditVal: string;
  refreshMarketbyIdEntity: boolean;
  marketUpdatedStatus: boolean;
  deletedMarketsList: TLoanFiltersData | null;
  activeMarketTab: string;
  apprRejectFields: TMarketAction | null
};

const initialState: TInitialState = {
  dateRange: {
    fromDate: moment().startOf("month").format("YYYY-MM-DD"),
    toDate: moment().endOf("month").format("YYYY-MM-DD"),
  },
  openMarketDetailsPanel: false,
  marketAddPanel: false,
  marketDetailsEditStatus: false,
  allMarketsData: [],
  refreshMarketsData: false,
  filteredMarketsData: [],
  marketsFiltersPanelOpenStatus: false,
  marketFilters: marketSavedFilters || {
    borrowers: [],
    markets: [],
    rms: [],
    status: [],
    filterMode: "",
    firstTimeApplied: "",
    loanType: [],
  },
  selectedMarketId: 0,
  marketDeatisById: null,
  bankPartnersData: [],
  mandiEmployeesData: [],
  addMarketDetails: {
    address: {
      addressLine: "",
      city: "",
      dist: "",
      latitude: 0,
      longitude: 0,
      marketId: "",
      pincode: 0,
      state: "",
      traderId: 0,
    },
    adminId: 0,
    apmcStatus: "",
    bankPartners: [],
    caCount: 0,
    crops: [],
    empCount: 0,
    employee: {
      emailId: "",
      empId: "",
      id: 0,
      mobile: "",
      name: "",
      onoId: 0,
      ors: 0,
      profilePic: "",
      region: "",
      status: 0,
    },
    headName: "",
    holidays: [],
    licenceType: "",
    maketKnownFor: "",
    marketId: "",
    marketImgs: [],
    marketName: "",
    marketOpDays: "",
    marketOps: [],
    marketOrs: 0,
    marketSize: "",
    marketType: "",
    mid: 0,
    noofBuyers: 0,
    onoId: 0,
    peakHours: "",
    rmOrs: 0,
    softwares: [],
    status: 0,
    traderCount: 0,
    transCount: 0,
    users: {
      cashCount: 0,
      clickCount: 0,
      marketId: 0,
      tradeCount: 0,
      total: 0,
    },
    remarks: "",
    shopCount: ''
  },
  softwarePartnersData: [],
  marketImages: [],
  refreshAllMarketsEntity: false,
  marketAddEditVal: "",
  refreshMarketbyIdEntity: false,
  marketUpdatedStatus: false,
  deletedMarketsList: null,
  activeMarketTab: "ALL",
  apprRejectFields: {
    rejectRemarks: '',
    approveRemarks: '',
    empOrs: '',
    marketOrs: ""
  }
};

export const marketSlice = createSlice({
  name: "marketDetails",
  initialState: initialState,

  reducers: {
    setDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
    setOpenMarketDetailsPanel: (state, action: PayloadAction<boolean>) => {
      state.openMarketDetailsPanel = action.payload;
    },
    setOpenMarketAddPanel: (state, action: PayloadAction<boolean>) => {
      state.marketAddPanel = action.payload;
    },
    setEditMarketDetailsStatus: (state, action: PayloadAction<boolean>) => {
      state.marketDetailsEditStatus = action.payload;
    },
    setAllMarketsData: (state, action: PayloadAction<TAllMarkets[]>) => {
      state.allMarketsData = action.payload;
    },
    setRefreshAllMarketsData: (state) => {
      state.refreshMarketsData = !state.refreshMarketsData;
    },
    setFilteredMarkets: (state, action: PayloadAction<TAllMarkets[]>) => {
      state.filteredMarketsData = action.payload;
    },
    setMarketFiltersPanelOpenStatus: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.marketsFiltersPanelOpenStatus = action.payload;
    },
    setMarketsFilters: (state, action) => {
      state.marketFilters = action.payload;
      localStorage.setItem(
        "marketFilters",
        JSON.stringify(state.marketFilters)
      );
    },
    resetMarketsFilters: (state) => {
      state.marketFilters = initialState.marketFilters;
      localStorage.removeItem("marketFilters");
    },
    setSelectedMarketId: (state, action: PayloadAction<number>) => {
      state.selectedMarketId = action.payload;
    },
    setMarketDetailsById: (
      state,
      action: PayloadAction<TMarketDetailsById | null>
    ) => {
      state.marketDeatisById = action.payload;
    },
    setBankPartnersData: (
      state,
      action: PayloadAction<TMandiBankSofwarePartners[]>
    ) => {
      state.bankPartnersData = action.payload;
    },
    setSoftwarePartnersData: (
      state,
      action: PayloadAction<TMandiBankSofwarePartners[]>
    ) => {
      state.softwarePartnersData = action.payload;
    },
    setMandiEmployeesData: (
      state,
      action: PayloadAction<TMandiEmployeeDetais[]>
    ) => {
      state.mandiEmployeesData = action.payload;
    },
    udpateAddMarketData: (
      state,
      action: PayloadAction<{
        addMarketData: TMarketDetailsById;
      }>
    ) => {
      state.addMarketDetails = action.payload.addMarketData;
    },
    setMarketImages: (state, action: PayloadAction<TMarketImgs[]>) => {
      state.marketImages = action.payload;
    },
    setRefreshAllMarketsEntity: (state) => {
      state.refreshAllMarketsEntity = !state.refreshAllMarketsEntity;
    },
    resetMarketDetails: (state) => {
      state.addMarketDetails = initialState.addMarketDetails;
      state.marketImages = initialState.marketImages;
    },
    setMarketAddEditVal: (state, action: PayloadAction<string>) => {
      state.marketAddEditVal = action.payload;
    },
    setRefreshMarketByIdEntity: (state) => {
      state.refreshMarketbyIdEntity = !state.refreshMarketbyIdEntity;
    },
    setMarketUpdated: (state, action) => {
      state.marketUpdatedStatus = action.payload;
    },
    setDeletedMarketsList: (state, action: PayloadAction<TLoanFiltersData>) => {
      state.deletedMarketsList = action.payload;
    },
    setActiveMarketTab: (state, action: PayloadAction<string>) => {
      state.activeMarketTab = action.payload;
    },
    setApprRejectFields: (state, action: PayloadAction<TMarketAction | null>) => {
      state.apprRejectFields = action.payload
    },
    resetApprRejectFields: (state) => {
      state.apprRejectFields = initialState.apprRejectFields
    }
  },
});

export const {
  setDateRange,
  setOpenMarketDetailsPanel,
  setOpenMarketAddPanel,
  setEditMarketDetailsStatus,
  setAllMarketsData,
  setRefreshAllMarketsData,
  setFilteredMarkets,
  setMarketsFilters,
  resetMarketsFilters,
  setMarketFiltersPanelOpenStatus,
  setSelectedMarketId,
  setMarketDetailsById,
  setBankPartnersData,
  setMandiEmployeesData,
  udpateAddMarketData,
  setSoftwarePartnersData,
  setMarketImages,
  setRefreshAllMarketsEntity,
  resetMarketDetails,
  setMarketAddEditVal,
  setRefreshMarketByIdEntity,
  setMarketUpdated,
  setDeletedMarketsList,
  setActiveMarketTab,
  setApprRejectFields,
  resetApprRejectFields
} = marketSlice.actions;
export default marketSlice.reducer;
